import type { ActionClassificationCommandProperties } from '@atlassian/rovo-content-bridge-api-commands/commands/action-classification-command';

import type { DocumentUpdateCommandProcessor } from '../stream-processors/update-command-processor';
import {
	CommandHandler,
	type ICommandHandler,
	type PassThroughCommandProps,
} from './command-handler';

export class ActionClassificationCommandHandler
	extends CommandHandler<ActionClassificationCommandProperties, void>
	implements ICommandHandler<ActionClassificationCommandProperties, void>
{
	constructor(
		props: PassThroughCommandProps,
		private updateCommandProcessor: DocumentUpdateCommandProcessor,
	) {
		super(props);
	}

	execute(payload: ActionClassificationCommandProperties): void {
		this.updateCommandProcessor.setActionMetadata(payload.data);
	}
}
